import React from 'react';
import InnerHTML from 'dangerously-set-html-content';
import { ISanityBookeoBookingWidget } from '../../fragments/sanity-bookeo-booking-widget-parts';
import Script from 'react-load-script';

const html = `<div id="bookeo-booking-widget">
    <script
      type="text/javascript"
      src="https://bookeo.com/widget.js?a=41570KU3X37166A9216599"
    ></script>
  </div>`;

interface BookeoBookingWidgetProps {
  bookeoBookingWidget: ISanityBookeoBookingWidget;
}

const BookeoBookingWidget = ({
  bookeoBookingWidget,
}: BookeoBookingWidgetProps): JSX.Element | null => {
  React.useEffect(() => {
    // console.log(window.location.href);
    const script2 = document.createElement('script');

    script2.src = window.location.href.includes('#voucher')
      ? 'https://bookeo.com/widget.js?a=41570KU3X37166A9216599&startmode=buyvoucher'
      : 'https://bookeo.com/widget.js?a=41570KU3X37166A9216599';
    script2.async = true;

    document.getElementById('bookeo-booking-widget')?.appendChild(script2);
  }, []);
  return (
    <div id="bookeo-booking-widget" className="w-9/12 mx-auto">
      {/* <div className="w-9/12 mx-auto"> */}
      {/* <InnerHTML html={html} /> */}
      {/* <Script
          url="https://bookeo.com/widget.js?a=41570KU3X37166A9216599"
          onCreate={() => console.log(' ')}
          onError={() => console.log(' ')}
          onLoad={() => console.log(' ')}
        /> */}
      {/* </div> */}
    </div>
  );
};

export { BookeoBookingWidget };
